import React, { useState, useCallback } from 'react';
import Toast from './Toast';

export default function ShareButton({ url, title, text, label = 'Share' }) {
  const [toast, setToast] = useState(null);

  const handleShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch {
        // user cancelled or share failed — fall through to clipboard
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setToast('Link copied!');
    } catch {
      setToast('Could not copy link.');
    }
  }, [url, title, text]);

  return (
    <>
      <button className="btn-tertiary btn-small" onClick={handleShare}>
        {label}
      </button>
      {toast && <Toast message={toast} onDismiss={() => setToast(null)} />}
    </>
  );
}
